module.exports = __webpack_public_path__ + "static/media/fuel-filter-change-red.0dba4924.svg";